import { gql } from '@apollo/client';

export const AuthQueryName = 'AuthQuery';

export const AUTH_QUERY = gql`
  query ${AuthQueryName} {
    viewer {
      premiumAccess {
        isPremium
        sources
        expiresAt
      }
      user {
        email
        id
        slug
        role
        displayName
        firstName
        lastName
        preferredLocale
        unseenChangelogCount
      }
    }
  }
`;
